(function () {
  'use strict';

  var isSyncing = false;
  var syncTimer;
  var globalBound = false;

  function getCartElement() {
    return document.querySelector('cart-notification');
  }

  function getSectionIds() {
    var cartEl = getCartElement();
    if (cartEl && typeof cartEl.getSectionsToRender === 'function') {
      return cartEl.getSectionsToRender().map(function (section) {
        return section.id;
      });
    }
    return ['minicart-form'];
  }

  function getCartAddUrl() {
    var base = (window.routes && window.routes.cart_add_url) || '/cart/add';
    return base.indexOf('.js') === base.length - 3 ? base : base + '.js';
  }

  function getCartChangeUrl() {
    var base = (window.routes && window.routes.cart_change_url) || '/cart/change';
    return base.indexOf('.js') === base.length - 3 ? base : base + '.js';
  }

  function cartFetchConfig() {
    return {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };
  }

  function parseJsonResponse(response) {
    return response.text().then(function (text) {
      var data = {};
      if (text) {
        try {
          data = JSON.parse(text);
        } catch (err) {
          throw new Error('Could not update cart.');
        }
      }
      if (!response.ok || (data.status && data.status >= 400)) {
        throw new Error(data.description || data.message || 'Could not update cart.');
      }
      return data;
    });
  }

  function setButtonLoading(button, loading) {
    if (!button) return;
    button.classList.toggle('is-loading', loading);
    button.disabled = loading;
  }

  function handleCartError(error) {
    if (typeof showToast === 'function') {
      showToast(error && error.message ? error.message : 'Could not update cart.', 4000, 'modal-error');
    }
  }

  function updateCartCounts(cart) {
    if (!cart || cart.item_count === undefined) return;

    document.querySelectorAll('.cart-count').forEach(function (el) {
      if (el.classList.contains('cart-count-drawer')) {
        el.textContent = '(' + cart.item_count + ')';
      } else {
        el.textContent = cart.item_count > 100 ? '~' : cart.item_count;
      }
    });

    if (document.querySelector('header-total-price')) {
      document.querySelector('header-total-price').updateTotal(cart);
    }

    var cartFreeShip = document.querySelector('free-ship-progress-bar');
    if (cartFreeShip) {
      cartFreeShip.init(cart.items_subtotal_price);
    }
  }

  function refreshMinicartSections(sections) {
    if (!sections) return;

    getSectionIds().forEach(function (sectionId) {
      if (!sections[sectionId]) return;

      var elementToReplace = document.getElementById(sectionId);
      if (!elementToReplace) return;

      var html = new DOMParser().parseFromString(sections[sectionId], 'text/html');
      var minicartContent = html.querySelector('#minicart-form');

      if (minicartContent) {
        elementToReplace.innerHTML = minicartContent.innerHTML;
      }
    });

    var cartEl = getCartElement();
    if (!cartEl) return;

    if (typeof cartEl.restoreMinicartCountdown === 'function') {
      cartEl.restoreMinicartCountdown();
    }
    if (typeof cartEl.cartAction === 'function') {
      cartEl.cartAction();
    }
  }

  function syncUpsellActions(upsell, cart) {
    if (!upsell) return;

    upsell.querySelectorAll('[data-upsell-actions]').forEach(function (actions) {
      var variantId = actions.getAttribute('data-variant-id');
      var item = (cart.items || []).find(function (cartItem) {
        return String(cartItem.variant_id) === String(variantId);
      });
      var addBtn = actions.querySelector('[data-upsell-add]');
      var qtyWrap = actions.querySelector('[data-upsell-qty]');
      var qtyValue = actions.querySelector('[data-upsell-qty-value]');
      var minusBtn = actions.querySelector('[data-upsell-minus]');
      var plusBtn = actions.querySelector('[data-upsell-plus]');

      if (!addBtn || !qtyWrap || !qtyValue) return;

      if (item && item.quantity > 0) {
        actions.dataset.lineKey = item.key;
        qtyValue.textContent = item.quantity;
        addBtn.hidden = true;
        qtyWrap.hidden = false;
      } else {
        actions.removeAttribute('data-line-key');
        qtyValue.textContent = '1';
        addBtn.hidden = false;
        qtyWrap.hidden = true;
        addBtn.disabled = addBtn.hasAttribute('data-sold-out');
      }

      setButtonLoading(addBtn, false);
      setButtonLoading(minusBtn, false);
      setButtonLoading(plusBtn, false);
    });
  }

  function syncBlockVisibility(upsell, cart) {
    if (!upsell) return;

    var shouldShow = cart && cart.item_count > 0;

    upsell.hidden = !shouldShow;
    upsell.classList.toggle('hidden', !shouldShow);
  }

  function fetchCartAndSync() {
    var upsell = document.getElementById('ph-minicart-pickle-upsell');

    return fetch('/cart.json')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        updateCartCounts(cart);
        syncUpsellActions(upsell, cart);
        syncBlockVisibility(upsell, cart);
        return cart;
      });
  }

  function scheduleCartSync() {
    if (isSyncing) return;
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      fetchCartAndSync();
    }, 250);
  }

  function publishCartUpdate() {
    if (typeof notifyCartChange === 'function') {
      notifyCartChange('ph-pdp-pickle-upsell');
      return;
    }

    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ph-pdp-pickle-upsell' });
    }

    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  function bindGlobalHandlers() {
    if (globalBound) return;
    globalBound = true;

    document.addEventListener('click', function (event) {
      var upsellNavLink = event.target.closest('#ph-minicart-pickle-upsell a[href]');
      if (upsellNavLink && !upsellNavLink.closest('[data-upsell-actions]')) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      var addBtn = event.target.closest('[data-upsell-add]');
      var minusBtn = event.target.closest('[data-upsell-minus]');
      var plusBtn = event.target.closest('[data-upsell-plus]');
      var activeBtn = addBtn || minusBtn || plusBtn;
      if (!activeBtn) return;

      var actions = activeBtn.closest('[data-upsell-actions]');
      if (!actions || !actions.closest('#ph-minicart-pickle-upsell')) return;

      event.preventDefault();
      event.stopPropagation();

      var variantId = actions.getAttribute('data-variant-id');
      var qtyValue = actions.querySelector('[data-upsell-qty-value]');

      if (addBtn) {
        if (isSyncing || !variantId || addBtn.disabled) return;

        isSyncing = true;
        setButtonLoading(addBtn, true);

        var formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');
        formData.append('sections', getSectionIds());
        formData.append('sections_url', window.location.pathname);

        fetch(getCartAddUrl(), {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: formData,
        })
          .then(parseJsonResponse)
          .then(function (data) {
            refreshMinicartSections(data.sections);
            return fetch('/cart.json').then(function (response) {
              return response.json();
            });
          })
          .then(function (cart) {
            updateCartCounts(cart);
            publishCartUpdate();
            return cart;
          })
          .catch(handleCartError)
          .finally(function () {
            setButtonLoading(addBtn, false);
            isSyncing = false;
          });
        return;
      }

      if (!qtyValue) return;

      var delta = minusBtn ? -1 : 1;
      if (isSyncing) return;

      var currentQty = parseInt(qtyValue.textContent, 10) || 0;
      var lineKey = actions.dataset.lineKey;
      if (!lineKey) {
        fetchCartAndSync();
        return;
      }

      var nextQty = currentQty + delta;
      if (nextQty < 0) nextQty = 0;

      isSyncing = true;
      setButtonLoading(activeBtn, true);
      qtyValue.textContent = nextQty > 0 ? nextQty : currentQty;

      var changeConfig = cartFetchConfig();
      changeConfig.body = JSON.stringify({
        id: lineKey,
        quantity: nextQty,
        sections: getSectionIds(),
        sections_url: window.location.pathname,
      });

      fetch(getCartChangeUrl(), changeConfig)
        .then(parseJsonResponse)
        .then(function (data) {
          refreshMinicartSections(data.sections);
          return fetch('/cart.json').then(function (response) {
            return response.json();
          });
        })
        .then(function (cart) {
          updateCartCounts(cart);
          publishCartUpdate();
          return cart;
        })
        .catch(function (error) {
          qtyValue.textContent = currentQty;
          handleCartError(error);
        })
        .finally(function () {
          setButtonLoading(activeBtn, false);
          isSyncing = false;
        });
    });

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') {
        scheduleCartSync();
      }
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.source === 'ph-pdp-pickle-upsell') return;
        scheduleCartSync();
      });
    }

    var minicartForm = document.getElementById('minicart-form');
    if (minicartForm && typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(function () {
        scheduleCartSync();
      });
      observer.observe(minicartForm, { childList: true, subtree: true });
    }
  }

  function initPickleUpsell() {
    bindGlobalHandlers();
    return fetchCartAndSync();
  }

  window.phInitPickleUpsell = initPickleUpsell;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPickleUpsell);
  } else {
    initPickleUpsell();
  }
})();
